import React from 'react'

export { getServerSideProps } from 'src/pages/[...path]/server'

const pagePathView = '/[...path]'

export { pagePathView }

export default () => <></>
